import { useMemo, useState } from 'react'

import { type TeamMemberStatistic } from '@api'

import { SearchInput } from '@/components/ui/search-input.tsx'
import { DataTable } from '@/components/ui/table/data-table.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'
import { getMemberColumns } from '@/modules/accounting/ui/members/constants.tsx'

interface Props {
  membersData: TeamMemberStatistic[]
  showCents?: boolean
  formattedRange?: string
}

export const AccountingMembersTable = ({
  membersData,
  showCents = true,
  formattedRange,
}: Props) => {
  const [query, setQuery] = useState('')

  const columns = useMemo(
    () =>
      getMemberColumns({
        showCents,
        onSetSalary: (data) => {
          openDialog({
            type: DIALOG_TYPE.SET_MEMBER_SALARY,
            data,
            showCents,
            formattedRange,
          })
        },
      }),
    [formattedRange, showCents],
  )

  const data = useMemo(
    () =>
      membersData.filter(({ username }) =>
        username!.toLowerCase().includes(query.toLowerCase()),
      ),
    [membersData, query],
  )

  return (
    <DataTable
      title="All Members"
      testId="all-members-table"
      searchColumn="username"
      enableSorting
      columns={columns}
      data={data}
      enablePagination
      extra={
        <SearchInput
          value={query}
          onInputChange={setQuery}
          placeholder="Search Member"
          testId="all-members-table-search-input"
        />
      }
    />
  )
}
